import ReactGA from 'react-ga4';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
////////////////////////////////////////////////////////////////////
import {
	DailyTaskOption,
	EarnTopIcon,
	PageTitle,
	TaskDetail,
	TaskItem,
} from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';
import { Reward } from '@/core/interfaces';

const Earn: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	// youtubeRewards commented here
	const { rewards } = useCustomSelector(
		(state) => state.rewards
	);

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: '/earn',
			title: 'Earn',
		});
	}, []);

	/*********************
	// #region States
	**********************/
	const [selectedReward, setSelectedReward] = useState<Reward>();
	const [visibleTaskDetail, setVisibleTaskDetail] = useState<boolean>(false);

	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="mx-4 flex flex-col justify-center items-center gap-3 pb-32">
				<div className="flex flex-col gap-4 justify-center items-center ">
					<EarnTopIcon classes="mt-8 w-[200px]" />
					<div className="flex flex-col items-center">
						<PageTitle>{t('earn.title')}</PageTitle>
					</div>
				</div>
				<div className="w-full flex flex-col">
					<p className="text-md font-semibold">
						{t('earn.dailyTask')}
					</p>
					<div className="mt-3">
						<DailyTaskOption
							title="Daily reward"
							path="/daily-rewards"
							onClickOption={() => {}}
						/>
					</div>
				</div>
				{/* Remove dojo tasks */}
				{/* <div className="w-full flex flex-col mt-4">
					{youtubeRewards.length > 0 && (
						<p className="text-md font-semibold">
							{t('earn.youtubeTask')}
						</p>
					)}
					<div className="mt-3 flex flex-col gap-3">
						{youtubeRewards.map((element) => (
							<TaskItem
								key={element.id}
								reward={element}
								onSelectTask={(reward) => {
									setSelectedReward(reward);
									setVisibleTaskDetail(true);
								}}
							/>
						))}
					</div>
				</div> */}

				<div className="w-full flex flex-col mt-4">
					{rewards.length > 0 && (
						<p className="text-md font-semibold">
							{t('earn.socialTask')}
						</p>
					)}
					<div className="mt-3 flex flex-col gap-3">
						{rewards.map((element) => (
							<TaskItem
								key={element.id}
								reward={element}
								onSelectTask={(reward) => {
									setSelectedReward(reward);
									setVisibleTaskDetail(true);
								}}
							/>
						))}
					</div>
				</div>

				{selectedReward && (
					<TaskDetail
						isOpen={visibleTaskDetail}
						onClose={setVisibleTaskDetail}
						reward={selectedReward}
					/>
				)}
			</div>
		</>
	);
};

export default Earn;
